import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { useEffect } from 'react';
const ResponsiveContext = React.createContext({
    sm: false,
    md: false,
    lg: false,
    xl: false,
    height: false,
    portrait: false,
    touch: false,
});
ResponsiveContext.displayName = 'ResponsiveContext';
export function ResponsiveProvider(props) {
    const [state, setState] = React.useState(getResponsive());
    const refresh = () => {
        setState(getResponsive());
    };
    useEffect(() => {
        smQuery().addEventListener('change', refresh);
        mdQuery().addEventListener('change', refresh);
        lgQuery().addEventListener('change', refresh);
        xlQuery().addEventListener('change', refresh);
        heightQuery().addEventListener('change', refresh);
        portraitQuery().addEventListener('change', refresh);
    }, []);
    return _jsx(ResponsiveContext.Provider, { value: state, children: props.children });
}
export function useResponsive() {
    const appState = React.useContext(ResponsiveContext);
    return appState;
}
export function getResponsive() {
    return {
        sm: smQuery().matches,
        md: mdQuery().matches,
        lg: lgQuery().matches,
        xl: xlQuery().matches,
        height: heightQuery().matches,
        portrait: portraitQuery().matches,
        touch: touchQuery().matches,
    };
}
const smQuery = () => window.matchMedia('(min-width: 576px)');
const mdQuery = () => window.matchMedia('(min-width: 768px)');
const lgQuery = () => window.matchMedia('(min-width: 992px)');
const xlQuery = () => window.matchMedia('(min-width: 1200px)');
const heightQuery = () => window.matchMedia('(min-height: 700px)');
const portraitQuery = () => window.matchMedia('(orientation: portrait)');
const touchQuery = () => window.matchMedia('(pointer: coarse)');
